export default __webpack_public_path__ + "static/media/PlanCDesktop.0dbf9298.png";